import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Collapse } from 'antd';
import {
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { axiosInstance, get_file_name } from '../../shared/utils/axios';
import { colors } from '../../config/constants';
import FileDownload from 'js-file-download';

const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 25vw;
  width: 25vw;
  background-color: ${colors.COLOR_GRAY};
  color: ${colors.COLOR_WHITE}
  height: auto;
`;

const DownloadLink = styled.a`
  font-size: 1em;
`;

const BaconQuestionContainer = styled.div`
  display: flex;
  justify-content: center;
  img {
    max-width: 15vh;
    height: 200px;
  }
  p {
    font-size: 1.3em;
  }
  padding-top: 20px;
`;

const BaconQuestionHeading = styled.div`
  display: flex;
  justify-content: center;
  font-family: LexiaAd;
`;

const BaconQuestionBreak = styled.hr`
  width: 85%;
  height: 1px;
  border-width: 0;
  color: ${colors.COLOR_GRAY_BUTTON_OUTLINE};
  background-color: ${colors.COLOR_GRAY_BUTTON_OUTLINE};
`;

const BaconQuestionNotes = styled.div`
  margin-top: 2vh;
  color: ${colors.COLOR_BACON_SAYS_TEXT};
  display: flex;
  text-align: left;
  font-size: 1em;
  padding: 0 12%;
  flex-direction: column;

  strong {
    margin-top:20px;
    margin-bottom: 20px;
  }
`;

const GifContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 150px;
`;

const WarningContainer = styled.div`
  display: flex;
  margin-left: -15px;
`;

const { Panel } = Collapse;

const text = `
  The first time you install bacon, you need to run a pre-install script.
  This script will install pre-requisites needed for Bacon to run.
`;

const Notes = ({ gif, notes, warning}) => {
  const genExtra = () => (
    <>
      <span style={{fontSize:'1.3em'}}>Important</span>
      <FontAwesomeIcon
        icon={faExclamationTriangle}
        color='yellow'
        onClick={event => {
          // If you don't want click extra trigger collapse, you can prevent this:
          event.stopPropagation();
        }}
        style={{ marginLeft: 6 }}
      />
    </>
  );

  const downloadPreInstall = () => {
    axiosInstance({
      method: 'get',
      url: '/installers/pre_install_script/',
      responseType: 'blob',
    })
      .then(function (response) {

        FileDownload(response.data, get_file_name(response.headers));
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <RightPanel>
      <BaconQuestionContainer>
        <img
          src={`${process.env.PUBLIC_URL}/images/bacon_question.svg`}
          alt="Bacon logo"
        />
      </BaconQuestionContainer>
      <BaconQuestionHeading>Patch says...</BaconQuestionHeading>
      <BaconQuestionBreak />
      {gif && <GifContainer>
        {gif && <img
          src={`${process.env.PUBLIC_URL}/gifs/${gif}.gif`}
          alt="Bacon logo"
          style={{ width: 200, objectFit: 'scale-down' }}
        />}
      </GifContainer>}
      <BaconQuestionNotes>
        <WarningContainer>
          {warning && <Collapse defaultActiveKey={['1']} ghost>
            <Panel header={genExtra()} key="1">
              <p style={{fontSize:'1em'}}>{text}</p>
              <DownloadLink onClick={downloadPreInstall}>Download script</DownloadLink>
            </Panel>
          </Collapse>}
        </WarningContainer>
        {typeof notes === 'object' ? notes.map(n => n.title ? <strong style={{margin:'1em 0'}} key={n.title}>{n.title}</strong> : <p key={n} style={{fontSize:'1em'}}>{n}</p>) : notes}
      </BaconQuestionNotes>
    </RightPanel>
  );
};



Notes.propTypes = {
  gif: PropTypes.string,
  notes: PropTypes.string,
  warning: PropTypes.bool
};

export default Notes;